// extracted by mini-css-extract-plugin
export var active = "_g2-7";
export var blink = "_g2-8";
export var dropDownSelector = "_g2-4";
export var dropDownWrapper = "_g2-3";
export var fakeCursor = "_g2-6";
export var fontSizeButton = "_g2-9";
export var formQuillEditor = "_g2-0";
export var pressed = "_g2-a";
export var qlBlank = "_g2-1";
export var textFormattingToolbar = "_g2-2";
export var textToolbarOption = "_g2-5";